import { CommonConstant } from '../../app.constants';
import { UserService } from '../../services/user.service';
import { Title } from '@angular/platform-browser';
import { ActivePages } from '../../services/event-tracker/event-tracker.service';
import { Kpi } from '../../../models/common';
import { InfluencerService } from '../../services/influencer/influencer.service';
import { PlaceholderVisibilityService } from '../../services/placeholder-visibility/placeholder-visibility.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CampaignService } from '../../services/campaign/campaign.service';
import { CommunicationService } from '../../services/communication/communication.service';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../services/modal/modal.service';
import { PdfExportService } from '../../services/export-pdf/pdf-export.service';
import { PdfViewerService } from '../../main/pdf-viewer/pdf-viewer.service';
import { AppSettings } from '../../utils/app-settings';
var InfluencerTab;
(function (InfluencerTab) {
    InfluencerTab[InfluencerTab["CAMPAIGN"] = 1] = "CAMPAIGN";
    InfluencerTab[InfluencerTab["CHAT"] = 2] = "CHAT";
})(InfluencerTab || (InfluencerTab = {}));
var InfluencerCampaignDetailComponent = /** @class */ (function () {
    function InfluencerCampaignDetailComponent(influencerService, placeholderService, route, router, userService, modalService, pdfService, pdfViewerService, campaignService, communicationService, title) {
        this.influencerService = influencerService;
        this.placeholderService = placeholderService;
        this.route = route;
        this.router = router;
        this.userService = userService;
        this.modalService = modalService;
        this.pdfService = pdfService;
        this.pdfViewerService = pdfViewerService;
        this.campaignService = campaignService;
        this.communicationService = communicationService;
        this.title = title;
        this.showActivityLog = true;
        this.campaignSilder = [
            { i: 0, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name, selected: false },
            { i: 1, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name, selected: false },
            { i: 2, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACTIVE.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACTIVE.name, selected: false },
            { i: 3, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.PUBLISHED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.PUBLISHED.name, selected: false }
        ];
    }
    InfluencerCampaignDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activeTabIndex = InfluencerTab.CAMPAIGN;
        this.route.params.subscribe(function (params) {
            _this.preSelectedInfluencerId = params.campaignId;
        });
        this.loadDetailsCampaignInfluencer(this.preSelectedInfluencerId);
    };
    InfluencerCampaignDetailComponent.prototype.ngOnDestroy = function () {
        if (this.exportPdfSubcription) {
            this.exportPdfSubcription.unsubscribe();
        }
    };
    InfluencerCampaignDetailComponent.prototype.loadInfluencerConversation = function (campaignCompany, influencerId) {
        var _this = this;
        this.communicationService.fetchInfluencerConversation(campaignCompany, influencerId).subscribe(function (res) {
            _this.conversation = res;
        });
    };
    InfluencerCampaignDetailComponent.prototype.changeStatus = function (event) { };
    InfluencerCampaignDetailComponent.prototype.onChangeCampaign = function (e) {
        this.loadDetailsCampaignInfluencer(e.campaignInfluencerId);
    };
    InfluencerCampaignDetailComponent.prototype.setChatTabSelected = function () {
        this.activeTabIndex = InfluencerTab.CHAT;
    };
    InfluencerCampaignDetailComponent.prototype.loadDetailsCampaignInfluencer = function (campaignInfluencerId) {
        var currentInfluencer = this.userService.getInfluencerInfo();
        this.influencerId = currentInfluencer.id;
        this.getCampaignBelongedToInfluencer(currentInfluencer.id, campaignInfluencerId);
    };
    InfluencerCampaignDetailComponent.prototype.getCampaignInfluencerDetail = function (campaignInfluencerId) {
        var _this = this;
        this.influencerService.getCampaignInfluencerDetail(campaignInfluencerId).subscribe(function (res) {
            if (res && res.campaign) {
                _this.selectedCampaign = res.campaign;
                _this.campaignKeywords = res.campaign.projectKeywords.map(function (pk) { return pk.keyword.keyword; });
                // Should load actual message here
                _this.loadInfluencerConversation(_this.selectedCampaign.company_id, _this.influencerId);
            }
        });
    };
    InfluencerCampaignDetailComponent.prototype.getCampaignBelongedToInfluencer = function (influencerId, selectedCampaignInfluencerId) {
        var _this = this;
        // get campaign list of influencer
        var params = {
            influencer_id: influencerId,
            page: CommonConstant.START_PAGE_INDEX,
            page_size: 50
        };
        this.influencerService.getCampaignListOfInfluencer(params)
            .subscribe(function (res) {
            _this.campaignList = res.filter(function (cp) { return _this.isConfirmedCampaign(cp); });
            if (!Array.isArray(_this.campaignList) || _this.campaignList.length === 0) {
                return;
            }
            var selectedCampaign;
            if (selectedCampaignInfluencerId) {
                selectedCampaign = _this.campaignList.find(function (item) { return item.campaignInfluencerId === Number(selectedCampaignInfluencerId); });
            }
            if (selectedCampaign) {
                _this.selectedCampaignId = selectedCampaign.id;
                _this.getCampaignInfluencerData(selectedCampaign.campaignInfluencerId);
                _this.getCampaignInfluencerDetail(selectedCampaign.campaignInfluencerId);
            }
            else {
                _this.router.navigate(['dashboard', 'campaigns']);
            }
        });
    };
    InfluencerCampaignDetailComponent.prototype.isActiveCampaign = function (cp) {
        if (!cp || !cp.status) {
            return false;
        }
        return cp.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACTIVE.name.toLowerCase()
            || cp.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name.toLowerCase()
            || cp.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.PUBLISHED.name.toLowerCase();
    };
    /**
     * A campaign which has been reviewed by influencer
     * @param cp
     * @returns {boolean}
     */
    InfluencerCampaignDetailComponent.prototype.isConfirmedCampaign = function (cp) {
        if (!cp || !cp.status) {
            return false;
        }
        return cp.status !== CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name.toLowerCase()
            && cp.status !== CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INTERESTED.name.toLowerCase();
    };
    InfluencerCampaignDetailComponent.prototype.getCampaignInfluencerData = function (campaignInfluencerId) {
        var _this = this;
        this.placeholderService.show(CommonConstant.INFLUENCER_CAMPAIGN_DETAILS_HOLDER);
        this.influencerService.getCampaignInfluencerData(campaignInfluencerId)
            .subscribe(function (res) {
            // parse KPI
            var postKpi = new Kpi();
            postKpi.engagement.value = res.globalKpi.engagement;
            postKpi.impact.value = res.globalKpi.impact * 100;
            postKpi.impressions.value = res.globalKpi.impression;
            postKpi.reach.value = res.globalKpi.reach;
            postKpi.post.value = res.globalKpi.post;
            _this.campaignInfluencerKPI = postKpi;
            // parse post list
            var postList = res.postList.map(function (post) { return ({
                imageUrl: post.image,
                title: post.page_title,
                date: post.date,
                relativePath: post.relativePath,
                fullUrl: post.full_url,
                platformBlogs: post.platformBlogs,
                platformInstagram: post.platformInstagram,
                platformYoutube: post.platformYoutube,
                platformSnapchat: post.platformSnapchat,
                platformTwitter: post.platformTwitter,
                platformPinterest: post.platformPinterest,
                platformFacebook: post.platformFacebook,
                platformTiktok: post.platformTiktok,
                reach: post.reach.value,
                engagement: post.engagement.value,
                impressions: post.impression && post.impression.value > 0 ? post.impression.value : post.reach.value,
                impact: post.impact.value,
                urlHash: post.urlHash
            }); });
            _this.campaignPosts = postList;
            _this.updateSlider(res.campaign.status);
            _this.placeholderService.hide(CommonConstant.INFLUENCER_CAMPAIGN_DETAILS_HOLDER);
        });
    };
    InfluencerCampaignDetailComponent.prototype.updateSlider = function (status) {
        var normalizedStatus = status;
        if (this.isActiveCampaign({ status: status.toLowerCase() })) {
            normalizedStatus = CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACTIVE.name;
        }
        this.campaignSilder = this.campaignSilder.slice(0); // clone new slider
        this.campaignSilder.forEach(function (item) {
            if (item.name === normalizedStatus) {
                item.selected = true;
            }
            else {
                item.selected = false;
            }
        });
    };
    Object.defineProperty(InfluencerCampaignDetailComponent.prototype, "platformBackground", {
        get: function () {
            return this.userService.platformBackground;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerCampaignDetailComponent.prototype.getActivePageType = function (activeTabIndex) {
        switch (activeTabIndex) {
            case InfluencerTab.CAMPAIGN: {
                return ActivePages.INFLUENCER_CAMPAIGNS;
            }
            default:
                return ActivePages.INFLUENCER_OVERVIEW;
        }
    };
    InfluencerCampaignDetailComponent.prototype.showCampaign = function () {
        this.activeTabIndex = InfluencerTab.CAMPAIGN;
    };
    Object.defineProperty(InfluencerCampaignDetailComponent.prototype, "campaignActionData", {
        get: function () {
            return {};
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerCampaignDetailComponent.prototype, "isActiveCampaignTab", {
        get: function () {
            return this.activeTabIndex === InfluencerTab.CAMPAIGN;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerCampaignDetailComponent.prototype, "isActiveChatTab", {
        get: function () {
            return this.activeTabIndex === InfluencerTab.CHAT;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerCampaignDetailComponent.prototype.isAcivatedAdvertiserChat = function () {
        return !AppSettings.isDisableChat();
    };
    InfluencerCampaignDetailComponent.prototype.backToCampaignOverview = function () {
        this.router.navigate(['/dashboard/campaigns']);
    };
    InfluencerCampaignDetailComponent.prototype.exportPDF = function () {
        this.modalService.open(this.alertPdfDownloadPending, null, true, CommonConstant.PDF_EXPORT_NOTIFICATION_SHOWING_TIME);
        this.exportPdfSubcription = this.pdfViewerService.generateCampaignPdf(this.preSelectedInfluencerId).subscribe();
    };
    InfluencerCampaignDetailComponent.prototype.closeNotification = function () {
        this.modalService.close();
    };
    return InfluencerCampaignDetailComponent;
}());
export { InfluencerCampaignDetailComponent };



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-campaign-detail/influencer-campaign-detail.component.ts.pre-build-optimizer.js